/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import './src/styles/global.css'

// Disable blur filter for Firefox on Android to improve scrolling performance
export const onClientEntry = () => {
  if (typeof window !== 'undefined') {
    const isFirefox = /Firefox/i.test(navigator.userAgent);
    const isAndroid = /Android/i.test(navigator.userAgent);
    
    if (isFirefox && isAndroid) {
      document.documentElement.classList.add('no-blur-filter');
    }
  }
}
